export enum MindboxOperation {
  Step1 = 'Step1',
  Step2 = 'Step2',
  Step3 = 'Step3',
  Step4 = 'Step4',
  PressedButtonSNG = 'PressedButtonSNG',
}
